import { render } from "./PickerMonth.vue?vue&type=template&id=1779bdab"
import script from "./PickerMonth.vue?vue&type=script&lang=js"
export * from "./PickerMonth.vue?vue&type=script&lang=js"
script.render = render

export default script